module.exports = __webpack_public_path__ + "static/media/30.1af1703a.jpg";